/* eslint-disable @typescript-eslint/no-unused-vars */
import axios from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_PATH, localStorageKeys } from 'src/utils/constants'


type loginPayload = {
  email: string,
  password: string
}

export const loginUser = createAsyncThunk(
  'auth/login',
  async ({ email, password }: loginPayload, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const response = await axios.post(
        `${API_BASE_PATH}/api/v1/admin_login/`,
        { username: email, password },
        config,
      )
      return response.data
    } catch (error: any) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)


export const logoutUser = createAsyncThunk('auth/logout', async (payload, { rejectWithValue }) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem(localStorageKeys.accessToken),
      },
    }
    const response = await axios.post(`${API_BASE_PATH}/rest-auth/logout/`, {}, config)
    return response.data
  } catch (error: any) {
    // return custom error message from backend if present
    if (error.response && error.response.data.message) {
      return rejectWithValue(error.response.data.message)
    } else {
      return rejectWithValue(error.message)
    }
  }
})
